import Drawer from './drawer';

class DrawerQuickbuy extends Drawer {
    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
        this.productId = '';
    }

    openDrawer(e) {
        this.openButton = e.currentTarget;
        this.productUrl = this.openButton?.dataset.productUrl;

        if (this.openButton) {
            this.openButton.classList.add('button--loading');
        }

        if (this.productUrl) {
            this.fetchQuickbuyContent();
        }
    }

    fetchQuickbuyContent() {
        const url = `${this.productUrl}?view=quickbuy`;
        fetch(url)
        .then(response => response.text())
        .then(html => {
            this.drawerContentEl.innerHTML = html;
            this.drawerBtnsClose = this.drawerEl.querySelectorAll('.js-drawer-close');

            if (this.openButton) {
                this.openButton.classList.remove('button--loading');
            }

            super.openDrawer();
        })
    }

    bindEvents() {
        document.addEventListener('theme:drawer:cart:update', (e) => {
            if (this.isDrawerOpen) {
                this.drawerEl.classList.add('drawer-transition-out');
                document.removeEventListener('keyup', this.onEchap);
                document.removeEventListener('click', this.onClickOutside);
                this.isDrawerOpen = false;
                this.drawerEl.classList.remove('drawer--visible', 'drawer-transition-out');
                document.body.classList.remove(`${this.drawerName}-visible`);
            }
        });

        document.addEventListener('theme:filters:update', (e) => {
            // add event listeners attached on page load need to be re-updated on filter update
            super.bindEvents();
        });

        document.addEventListener('listing-load-more:update', (e) => {
            // add event listeners attached on page load need to be re-updated on filter update
            super.bindEvents();
        });

        super.bindEvents()
    }
}

customElements.define('w3-drawer-quickbuy', DrawerQuickbuy);
